// extracted by mini-css-extract-plugin
export default {"badge-container":"Badge_badge-container__ZzUOt","profile":"Badge_profile__6zlH4","badge":"Badge_badge__euuST"};